import { gql } from "graphql-tag";
export const DELETE_USER_MUTATION = gql`
  mutation deleteTeamMember($id: ID!) {
    deleteUser(id: $id)
  }
`;

export const ARCHIVE_USER_MUTATION = gql`
  mutation archiveTeamMember($id: ID!) {
    archiveUser(id: $id) {
      id
      isArchived
    }
  }
`;

export const RESTORE_USER_MUTATION = gql`
  mutation restoreTeamMember($id: ID!) {
    restoreUser(id: $id) {
      id
      isArchived
    }
  }
`;
